import React from 'react'
import { csx, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import type { mapOffersToProductPrice } from '../../../../core/utils/productSkuOfferConnection'
import { Price, DeliveryChannelIcon } from '../../../../core/components'
import { DeliveryChannelText } from './DeliveryChannelText'

export type PriceInfoProps = {
  offer: ReturnType<typeof mapOffersToProductPrice>[number] | undefined
}

export const PriceInfo = ({ offer }: PriceInfoProps) => {
  if (!offer) {
    return (
      <Text variant="display" tone="secondary">
        <FormattedMessage id="unavailable" />
      </Text>
    )
  }

  const shouldShowListPrice = offer.listPrice.amount > offer.netPrice.amount

  return (
    <div>
      {shouldShowListPrice && (
        <Text
          variant="detail"
          tone="secondary"
          className={csx({
            display: 'block',
            textDecoration: 'line-through',
          })}
        >
          <Price value={offer.listPrice.amount / 100} />
        </Text>
      )}
      <div
        className={csx({
          display: 'flex',
          alignItems: 'center',
        })}
      >
        <Text
          variant="display"
          className={csx({
            display: 'block',
          })}
        >
          <Price value={offer.netPrice.amount / 100} />
        </Text>
        <div
          className={csx({
            display: 'inline-flex',
            alignItems: 'center',
            border: '$neutral',
            paddingX: '$space-3',
            paddingY: '5px',
            borderRadius: '24px',
            marginLeft: '$space-2',
          })}
        >
          <DeliveryChannelIcon
            deliveryChannel={offer.deliveryChannel}
            size="small"
          />
          <Text
            variant="detail"
            className={csx({
              marginLeft: '$space-2',
            })}
          >
            <DeliveryChannelText deliveryChannel={offer.deliveryChannel} />
          </Text>
        </div>
      </div>
    </div>
  )
}
